import { FC, useCallback, useEffect, useState } from "react";

import { PercentSchemaItem, RowWithEmbeddedMetadata } from "@data-root/types";
import { inputGuard } from "../../hocs/guard";
import { InputNumber, Skeleton } from "antd";
import { SchemaItemProps, useField } from "@data-root/react";
import { View } from "@data-root/react";
import { Typography } from "antd";
import { Remarks } from "../remarks";

const { Title } = Typography;

export const PercentInput: FC<SchemaItemProps<PercentSchemaItem>> = inputGuard(
  ({ item }) => {
    const {
      loaded,
      displayName,
      placeholder,
      editable,
      show,
      defaultValue,
      subscribe,
      setValue: _setValue,
      remarks,
    } = useField<number>(item);

 /*    const handleSetValue = useCallback(
      (value: number | null) => {
        if (value === null) return setValue(null, "");
        setValue(value!, `${value}%`);
      },
      [setValue]
    );
 */

    const [value, setValue] = useState<number | null>(defaultValue);

    const handleSetValue = useCallback(
      (value: number | null) => {
        if (value === null) {
          setValue(null);
          _setValue(null, "");
          return;
        }
  
        setValue(value);
        _setValue(value, value?.toString() || "");
      },
  
      [_setValue]
    );
  
    useEffect(() => {
      const callback = (
        next: RowWithEmbeddedMetadata,
        options?: {
          init?: boolean;
          evaluation?: boolean;
        }
      ) => {
        if (options?.init) {
          setValue(next[item.id] as number);
          return;
        }
        if (!options?.evaluation) return;
  
        setValue(next[item.id] as number);
      };
  
      const unsubscribe = subscribe(callback);
  
      return () => {
        unsubscribe();
      };
    }, [item.id, subscribe]);
  
    if (!show) return null;

    return (
      <View style={{ width: "100%" }}>
        <Title level={5}>{displayName}</Title>

        {!loaded ? (
          <Skeleton.Input block active />
        ) : (
          <InputNumber
            style={{ width: "100%" }}
            min={item.min ?? 0}
            max={item.max ?? 100}
            readOnly={!editable}
            addonAfter="%"
            value={value as number}
            placeholder={placeholder}
            onChange={handleSetValue}
            inputMode="decimal"
            key={(item.id + value) as string}
          />
        )}

        <Remarks texts={remarks} />
      </View>
    );
  }
);
